let startPosX = 0,
  startPosY = 0;

export const PositionDraggable = {
  mounted() {
    this.el.addEventListener("mousedown", (e) => {
      if (e.target.tagName == "INPUT") return;

      startPosX = e.clientX;
      startPosY = e.clientY;

      popup = document.getElementById(this.el.dataset.draggableId);

      var onMouseMove = function (e) {
        const newPosX = startPosX - e.clientX;
        const newPosY = startPosY - e.clientY;

        startPosX = e.clientX;
        startPosY = e.clientY;

        popup.style.left = Math.max(-10, popup.offsetLeft - newPosX) + "px";
        popup.style.top = Math.max(-10, popup.offsetTop - newPosY) + "px";

        popup.style.right = null;
        popup.style.bottom = null;
      };

      document.addEventListener("mousemove", onMouseMove);

      document.addEventListener("mouseup", (e) => {
        document.removeEventListener("mousemove", onMouseMove);
      });
    });
  },
};
